module.exports = __webpack_public_path__ + "img/huaNan.ae31f395.png";